export const defaultReservationModuleConfig = {
  reservationProvider: "resos" as const,
  reservationAccessToken: "",
  reservationUrl: "",
  reservationEnabled: false,
  reservationSlotDuration: 60,
  reservationMaxPartySize: 10,
};
